
export interface InterestsState {
  isLoading: boolean | null;
  list: any[] | null
}
export const initialState = {
  isLoading: null,
  list: null
}